import shuffle from 'lodash/shuffle';
import { EARN_STORES_GET_SUCCESS, EARN_STORES_GET_FAILURE } from '../actions/types';
import config from '../configs';

const initialState = {
  config,
  merchants: [],
  isLoading: false,
  isLoaded: false,
};

const earnStores = (state = initialState, action) => {
  switch (action.type) {
    case EARN_STORES_GET_SUCCESS: {
      const placements = action.payload.response;
      const merchants = placements.map(placement => placement.merchant);
      return {
        ...state,
        merchants: shuffle(merchants),
        isLoading: false,
        isLoaded: true,
      };
    }
    case EARN_STORES_GET_FAILURE: {
      return {
        ...state,
        merchants: [],
        isLoading: false,
        isLoaded: true,
      };
    }
    default: {
      const { options = {} } = action;
      if (options.success === EARN_STORES_GET_SUCCESS) {
        return { ...state, isLoading: true };
      }

      return state;
    }
  }
};

export default earnStores;
